import AccountRouteConstants from 'Agent/Accounts/AccountRouteConstants';
import {fromResult, toPage} from 'Core/models/Async';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import PagedView from 'Shared/components/PagedView/PagedView';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';
import {NoOp} from 'Shared/utilities/IOUtilities';

type AccountDiscrepanciesProps = RouteComponentProps<{accountId: string; accountNumber: string}>;

const AccountDiscrepancies = (props: AccountDiscrepanciesProps) => {
  const {history, match} = props;
  const {discrepancies} = useSelector((state: ReducerState) => state.accountDetails);

  useEffect(() => {
    if (O.isNone(discrepancies)) {
      history.push(AccountRouteConstants.ACCOUNT_DETAILS(match.params.accountId, match.params.accountNumber));
    }
  }, []);

  return pipe(
    discrepancies,
    O.fold(
      () => <>No Discrepancies</>,
      discrepancySummaries => (
        <PagedView pagedViewKey="accountDiscrepancies" loadMore={NoOp} data={fromResult(toPage(discrepancySummaries))}>
          {columnProps => (
            <>
              <Column {...columnProps} title="Policy Number" default>
                {discrepancy => discrepancy.policyNumber}
              </Column>
              <Column {...columnProps} title="Insured Name" default>
                {discrepancy => discrepancy.insuredName}
              </Column>
              <Column {...columnProps} title="Bill Amount" default>
                {discrepancy => toMoneyValue(discrepancy.billAmount)}
              </Column>
              <Column {...columnProps} title="Paid Amount" default>
                {discrepancy => toMoneyValue(discrepancy.paidAmount)}
              </Column>
              <Column {...columnProps} title="Discrepancy Amount" default>
                {discrepancy => toMoneyValue(discrepancy.discrepancyAmount)}
              </Column>
              <Column {...columnProps} title="Issue Date" default>
                {discrepancy => toFormattedDateAsUTC(discrepancy.issueDate)}
              </Column>
              <Column {...columnProps} title="Policy Type" default>
                {discrepancy => discrepancy.policyType}
              </Column>
              <Column {...columnProps} title="Status" default>
                {discrepancy => discrepancy.status}
              </Column>
            </>
          )}
        </PagedView>
      )
    )
  );
};

export default AccountDiscrepancies;
